import { render, staticRenderFns } from "./TableTag.vue?vue&type=template&id=6003ca25&scoped=true"
import script from "./TableTag.vue?vue&type=script&lang=js"
export * from "./TableTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6003ca25",
  null
  
)

export default component.exports